module.exports = __webpack_public_path__ + "static/media/atuacao-001.31fd7a13.jpg";